webpackJsonp([98],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en/hotel.json": [
		115,
		10
	],
	"./ja/hotel.json": [
		116,
		9
	],
	"./ko/hotel.json": [
		117,
		8
	],
	"./zh-CN/hotel.json": [
		118,
		7
	],
	"./zh-TW/hotel.json": [
		119,
		6
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 10;

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(16);
__webpack_require__(6);
__webpack_require__(5);

__webpack_require__(101);

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, Vue) {

var init = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var moment, login, OwlCarousel, moreListPanels$;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 8));

                    case 2:
                        _context2.next = 4;
                        return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 12));

                    case 4:
                        _context2.next = 6;
                        return __webpack_require__.e/* import() */(11/* duplicate */).then(__webpack_require__.bind(null, 22));

                    case 6:
                        moment = _context2.sent;
                        _context2.next = 9;
                        return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 134));

                    case 9:
                        login = _context2.sent;
                        _context2.next = 12;
                        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 11));

                    case 12:
                        OwlCarousel = _context2.sent;

                        $(document).ready(function () {
                            OwlCarousel.initOwlCarousel();
                        });

                        $('.readmore').click(function (event) {
                            var that$ = $(this);
                            that$.closest('div.text-content').find('div.texthide').removeClass('texthide').addClass('showmore').end().find('div.overtext').remove();
                            that$.remove();
                        });

                        moreListPanels$ = $('.panel-collapse');

                        moreListPanels$.on('shown.bs.collapse', function () {
                            var toggleButton = $('div.morelist[href="#' + this.id + '"]');
                            if (typeof toggleButton.get(0).scrollIntoView === 'function') {
                                toggleButton.get(0).scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start'
                                });
                            }
                            toggleButton.trigger('changeMoreListText');
                        });
                        moreListPanels$.on('hidden.bs.collapse', function () {
                            var toggleButton = $('div.morelist[href="#' + this.id + '"]');
                            toggleButton.trigger('changeMoreListText');
                        });

                        $('.morelist').on('changeMoreListText', function () {
                            var collapse = $(this).attr('href');
                            var collapse$ = $(collapse);
                            var isOpen = collapse$.hasClass('in');

                            if (isOpen === true) {
                                $(this).find('.show-promotion-list').hide();
                                $(this).find('.hidden-promotion-list').show();
                            } else {
                                $(this).find('.hidden-promotion-list').hide();
                                $(this).find('.show-promotion-list').show();
                            }
                        });

                        $(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                            var text, fetchInventory, today, calendarInitDate, vm;
                            return regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                    switch (_context.prev = _context.next) {
                                        case 0:
                                            fetchInventory = function fetchInventory(cb) {
                                                var that = this;
                                                that.isLoading = true;
                                                that.checkInDate = '';
                                                $.ajax(urlPrefix + '/promotion/inventory/' + promotionNo, {
                                                    type: 'POST',
                                                    headers: {
                                                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                                                    },
                                                    data: {
                                                        'start-date': that.startDay.format('YYYY-MM-DD'),
                                                        'end-date': that.endDay.format('YYYY-MM-DD'),
                                                        'room-qty': that.roomQty,
                                                        'nights': that.nights,
                                                        'is-channel': that.isChannel
                                                    },
                                                    dataType: 'json',
                                                    success: function success(res) {
                                                        if (true === res.status) {
                                                            if (true === res.waiting) {
                                                                that.waiting_on = res.waiting;
                                                            }
                                                            var row = that.calendarRow;
                                                            var inventory = [];
                                                            var inventoryWeek;
                                                            for (var i = 0; i <= row; i++) {
                                                                inventoryWeek = [];
                                                                for (var j = 7 * i; j < 7 * (i + 1); j++) {
                                                                    if (j < that.calendar.firstDateDay) {
                                                                        inventoryWeek.push({
                                                                            current: false
                                                                        });
                                                                    } else if (j - that.calendar.firstDateDay >= that.calendar.endDate) {
                                                                        inventoryWeek.push({
                                                                            current: false
                                                                        });
                                                                    } else {
                                                                        inventoryWeek.push({
                                                                            date: moment(res.inventory[j - that.calendar.firstDateDay].date),
                                                                            price: res.inventory[j - that.calendar.firstDateDay].price,
                                                                            qty: res.inventory[j - that.calendar.firstDateDay].qty,
                                                                            available: res.inventory[j - that.calendar.firstDateDay].available,
                                                                            applicable: res.inventory[j - that.calendar.firstDateDay].applicable,
                                                                            isAfter: moment(res.inventory[j - that.calendar.firstDateDay].date).isSameOrAfter(moment().format('YYYY-MM-DD'), 'day'),
                                                                            current: true
                                                                        });
                                                                    }
                                                                }
                                                                inventory.push(inventoryWeek);
                                                            }
                                                            that.inventory = inventory;
                                                        } else {
                                                            alert(res.message);
                                                            cb();
                                                        }
                                                        that.isLoading = false;
                                                    }
                                                });
                                            };

                                            _context.next = 3;
                                            return __webpack_require__(10)("./" + locale + '/hotel.json');

                                        case 3:
                                            text = _context.sent;

                                            $('#select-promotion-group').change(function (event) {
                                                var that$ = $(this);
                                                var groupNo = that$.val();
                                                $('#change-promotion-group-loading').removeClass('hide');
                                                if (groupNo != 0) {
                                                    window.location = urlPrefix + '/' + hotelId + '/promotion/list/' + groupNo;
                                                } else {
                                                    window.location = urlPrefix + '/' + hotelId + '/promotion/list';
                                                }
                                            });

                                            $('#select-promoCode-group').change(function (event) {
                                                var that$ = $(this);
                                                var promoCode = that$.val().split("-");

                                                $('#change-promotion-group-loading').removeClass('hide');
                                                if (promoCode[1] != 0) {
                                                    window.location = urlPrefix + '/' + hotelId + '/promocode/' + promoCode[0] + '/' + promoCode[1];
                                                } else {
                                                    window.location = urlPrefix + '/' + hotelId + '/promocode/' + promoCode[0];
                                                }
                                            });

                                            $('#select-ticket-group').change(function (event) {
                                                var that$ = $(this);
                                                var groupNo = that$.val();

                                                $('#change-promotion-group-loading').removeClass('hide');
                                                if (groupNo != 0) {
                                                    window.location = urlPrefix + '/' + hotelId + '/ticket/list/' + groupNo;
                                                } else {
                                                    window.location = urlPrefix + '/' + hotelId + '/ticket/list';
                                                }
                                            });

                                            if (document.getElementById('vue-promotion') !== null) {
                                                today = moment();
                                                calendarInitDate = today.isBefore(moment(startDay)) ? moment(startDay) : today;
                                                vm = new Vue({
                                                    el: '#vue-promotion',
                                                    data: {
                                                        nights: nights,
                                                        isChannel: isChannel,
                                                        roomQty: 1,
                                                        calendar: {
                                                            today: today,
                                                            year: calendarInitDate.year(),
                                                            month: calendarInitDate.month() + 1,
                                                            firstDateDay: calendarInitDate.startOf('month').day(),
                                                            endDate: calendarInitDate.endOf('month').date()
                                                        },
                                                        waiting_on: false,
                                                        inventory: [],
                                                        checkInDate: '',
                                                        isWaiting: 0,
                                                        isLoading: false,
                                                        nextLoading: false
                                                    },
                                                    created: function created() {
                                                        // 先抓取第一個月份的庫存
                                                        fetchInventory.call(this);
                                                    },
                                                    computed: {
                                                        startDay: function (_startDay) {
                                                            function startDay() {
                                                                return _startDay.apply(this, arguments);
                                                            }

                                                            startDay.toString = function () {
                                                                return _startDay.toString();
                                                            };

                                                            return startDay;
                                                        }(function () {
                                                            var calendarStart = moment(startDay);
                                                            if (calendarStart.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month')) {
                                                                return calendarStart;
                                                            } else {
                                                                return moment([this.calendar.year, this.calendar.month - 1]).startOf('month');
                                                            }
                                                        }),
                                                        endDay: function (_endDay) {
                                                            function endDay() {
                                                                return _endDay.apply(this, arguments);
                                                            }

                                                            endDay.toString = function () {
                                                                return _endDay.toString();
                                                            };

                                                            return endDay;
                                                        }(function () {
                                                            var calendarEnd = moment(endDay);
                                                            if (calendarEnd.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month')) {
                                                                return calendarEnd;
                                                            } else {
                                                                return moment([this.calendar.year, this.calendar.month - 1]).endOf('month');
                                                            }
                                                        }),
                                                        calendarRow: function calendarRow() {
                                                            return Math.ceil((this.calendar.endDate + this.calendar.firstDateDay) / 7) - 1;
                                                        },
                                                        currentMonth: function currentMonth() {
                                                            return this.calendar.today.isSame(moment([this.calendar.year, this.calendar.month - 1]), 'month');
                                                        },
                                                        checkInDateSend: function checkInDateSend() {
                                                            if (this.checkInDate instanceof moment) {
                                                                return this.checkInDate.format('YYYY-MM-DD');
                                                            }
                                                            return '';
                                                        }
                                                    },
                                                    methods: {
                                                        prev: function prev() {
                                                            var changeDate = moment([this.calendar.year, this.calendar.month - 1]).subtract(1, 'months');
                                                            if (changeDate.isSameOrAfter(moment().format('YYYY-MM-DD'), 'month')) {
                                                                this.calendar.year = changeDate.year();
                                                                this.calendar.month = changeDate.month() + 1;
                                                                this.calendar.firstDateDay = changeDate.startOf('month').day();
                                                                this.calendar.endDate = changeDate.endOf('month').date();
                                                                fetchInventory.call(this, this.next);
                                                            } else {
                                                                alert(text.SystemText.NotFurther);
                                                            }
                                                        },
                                                        next: function next() {
                                                            var changeDate = moment([this.calendar.year, this.calendar.month - 1]).add(1, 'months');
                                                            this.calendar.year = changeDate.year();
                                                            this.calendar.month = changeDate.month() + 1;
                                                            this.calendar.firstDateDay = changeDate.startOf('month').day();
                                                            this.calendar.endDate = changeDate.endOf('month').date();
                                                            fetchInventory.call(this, this.prev);
                                                        },
                                                        selectRoomQty: function selectRoomQty() {
                                                            this.checkInDate = '';
                                                            fetchInventory.call(this, function () {});
                                                        },
                                                        selectNights: function selectNights() {
                                                            this.checkInDate = '';
                                                            fetchInventory.call(this, function () {});
                                                        },
                                                        selectCheckInDate: function selectCheckInDate(date, isWaiting, event) {
                                                            var this$ = $(event.target).closest('a');
                                                            this$.focus();
                                                            this.checkInDate = date;
                                                            this.isWaiting = isWaiting || 0;
                                                        },
                                                        backList: function backList() {
                                                            window.location = urlPrefix + '/promotion/list';
                                                        },
                                                        submitNext: function submitNext(event) {
                                                            var that = this;
                                                            if (that.checkInDate instanceof moment) {
                                                                that.nextLoading = true;
                                                                var form$ = $('#promotion-submit-form');
                                                                login.check(function (err, status, userInfo) {
                                                                    if (status === true) {
                                                                        form$.submit();
                                                                    } else {
                                                                        if (enableMember === true) {
                                                                            that.nextLoading = false;
                                                                            login.initModal($(event.target), function (target) {
                                                                                that.nextLoading = true;
                                                                                form$.submit();
                                                                            }, !!that.isWaiting);
                                                                        } else {
                                                                            form$.submit();
                                                                        }
                                                                    }
                                                                });
                                                            } else {
                                                                alert(text.SystemText.SelectDate);
                                                            }
                                                        }
                                                    }
                                                });
                                            }

                                        case 8:
                                        case 'end':
                                            return _context.stop();
                                    }
                                }
                            }, _callee, this);
                        })));

                        // 2022-12-02 國軍英雄館套裝訂房增加公告
                        $(document).ready(function () {
                            $('#autoNotice').get(0).click();
                        });

                        $('#Notice-remember').on('change', function () {
                            $.ajax(urlPrefix + '/api/index/notice', {
                                type: 'post',
                                headers: {
                                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr('content')
                                }
                            });
                        });

                    case 22:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function init() {
        return _ref.apply(this, arguments);
    };
}();

__webpack_require__(242);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

init();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(108)))

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[272]);


// WEBPACK FOOTER //
// js/build/promotion-55fb15e5827d0458f059.js